import { render, staticRenderFns } from "./datenschutz.vue?vue&type=template&id=659d5260&lang=pug&"
import script from "./datenschutz.vue?vue&type=script&lang=ts&"
export * from "./datenschutz.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VCol: require('/home/runner/work/EC-Website/EC-Website/node_modules/vuetify/lib/components/VGrid/VCol.js').default,VRow: require('/home/runner/work/EC-Website/EC-Website/node_modules/vuetify/lib/components/VGrid/VRow.js').default,VTab: require('/home/runner/work/EC-Website/EC-Website/node_modules/vuetify/lib/components/VTabs/VTab.js').default,VTabs: require('/home/runner/work/EC-Website/EC-Website/node_modules/vuetify/lib/components/VTabs/VTabs.js').default,VTabItem: require('/home/runner/work/EC-Website/EC-Website/node_modules/vuetify/lib/components/VTabs/VTabItem.js').default,VTabsItems: require('/home/runner/work/EC-Website/EC-Website/node_modules/vuetify/lib/components/VTabs/VTabsItems.js').default,VContainer: require('/home/runner/work/EC-Website/EC-Website/node_modules/vuetify/lib/components/VGrid/VContainer.js').default})
